var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ModalAjoutMvtStock", {
        ref: "modalAjoutArticleInventaire",
        attrs: {
          id: "modalAjoutArticleInventaire",
          disabled: !_vm.inventaireSelectionneNonValide,
          title: "Ajouter un article à l'inventaire",
          action: "in",
          mode: "inventaire"
        },
        on: {
          "envoyer-article": function($event) {
            return _vm.ajouterArticle($event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreFiltres", {
            key: "filtres" + _vm.keyFiltres,
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          }),
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          !_vm.inventaire
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _vm._v(
                    " Pour commencer un nouvel inventaire à partir du stock à la date correspondante, merci de sélectionner une date et de cliquer sur le bouton. "
                  )
                ])
              ])
            : _vm._e(),
          _vm.inventaire
            ? _c(
                "div",
                { staticClass: "card table-scroll height-responsive-100" },
                [
                  _c(
                    "div",
                    { staticClass: "card-header flex-center-space-between" },
                    [
                      _c("div", { staticClass: "flex-start" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.inventaire &&
                                _vm.inventaire.date &&
                                _vm.formatHumanDate(
                                  new Date(_vm.inventaire.date)
                                )
                            )
                          )
                        ]),
                        _vm.inventaireSelectionneNonValide
                          ? _c("span", { staticClass: "text-warning ml-5" }, [
                              _c("i", {
                                staticClass:
                                  "fas fa-exclamation-triangle text-warning"
                              }),
                              _vm._v(
                                " Inventaire en cours : Les mouvements de stock et les réceptions de commandes sont désactivés afin de ne pas fausser le stock"
                              )
                            ])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "flex-end" }, [
                        _c("span", { staticClass: "ml-5" }, [
                          _vm._v(
                            "Total HT : " +
                              _vm._s(
                                _vm._f("afficherPrix2")(
                                  _vm.valeurTotaleInventaire(_vm.inventaire)
                                )
                              )
                          )
                        ]),
                        _c("span", { staticClass: "ml-5" }, [
                          _vm._v(
                            "Total TTC : " +
                              _vm._s(
                                _vm._f("afficherPrix2")(
                                  _vm.valeurTTCTotaleInventaire(_vm.inventaire)
                                )
                              )
                          )
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-bordered table-sm text-center table-header-secondary"
                    },
                    [
                      _c("colgroup", [
                        _c("col", { attrs: { width: "120" } }),
                        _c("col"),
                        _c("col", { attrs: { width: "120" } }),
                        _c("col", { attrs: { width: "120" } }),
                        _vm.inventaireSelectionneNonValide
                          ? _c("col", { attrs: { width: "120" } })
                          : _vm._e(),
                        _c("col", { attrs: { width: "120" } }),
                        _c("col", { attrs: { width: "120" } }),
                        _vm.inventaireSelectionneNonValide
                          ? _c("col", { attrs: { width: "55" } })
                          : _vm._e()
                      ]),
                      _c("thead", [
                        _c("th", [_vm._v("Référence")]),
                        _c("th", { staticClass: "aligner-gauche" }, [
                          _vm._v("Désignation")
                        ]),
                        _c("th", [_vm._v("N° Lot")]),
                        _c("th", [_vm._v("DLC/DDM")]),
                        _vm.inventaireSelectionneNonValide
                          ? _c("th", [_vm._v("Stock")])
                          : _vm._e(),
                        _c("th", [_vm._v("Quantité")]),
                        _c("th", [_vm._v("Total HT")]),
                        _vm.inventaireSelectionneNonValide
                          ? _c("th", [_vm._v("Vérifié")])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _c("div", { staticClass: "table-body" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-sm table-bordered text-center"
                      },
                      [
                        _c("colgroup", [
                          _c("col", { attrs: { width: "120" } }),
                          _c("col"),
                          _c("col", { attrs: { width: "120" } }),
                          _c("col", { attrs: { width: "120" } }),
                          _vm.inventaireSelectionneNonValide
                            ? _c("col", { attrs: { width: "120" } })
                            : _vm._e(),
                          _c("col", { attrs: { width: "120" } }),
                          _c("col", {
                            attrs: {
                              width: _vm.inventaireSelectionneNonValide
                                ? 120
                                : 115
                            }
                          }),
                          _vm.inventaireSelectionneNonValide
                            ? _c("col", { attrs: { width: "50" } })
                            : _vm._e()
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.inventaire.zonesStockage, function(
                              zone,
                              iZone
                            ) {
                              return [
                                !_vm.filtreZonesDeStockage.length ||
                                _vm.filtreZonesDeStockage.includes(
                                  zone.designation
                                )
                                  ? _c(
                                      "tr",
                                      {
                                        key: "zone" + iZone,
                                        staticClass: "table-header-tertiary",
                                        staticStyle: {
                                          position: "sticky",
                                          top: "0",
                                          "z-index": "5"
                                        }
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              colspan: _vm.inventaireSelectionneNonValide
                                                ? 8
                                                : 6
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "container-fluid"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-8 flex-start"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            zone.designation.toUpperCase()
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-2 flex-end"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "afficherPrix"
                                                              )(
                                                                _vm.valeurTotaleZoneStockage(
                                                                  zone
                                                                )
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-2 aligner-droite"
                                                      },
                                                      [
                                                        _vm.inventaireSelectionneNonValide
                                                          ? _c("span", [
                                                              _vm.zoneStockageVerifiee(
                                                                zone
                                                              )
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                : _vm._e()
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.filtreZonesDeStockage.length ||
                                _vm.filtreZonesDeStockage.includes(
                                  zone.designation
                                )
                                  ? [
                                      _vm._l(_vm.obtenirLots(zone), function(
                                        lot,
                                        iLot
                                      ) {
                                        return [
                                          _vm
                                            .formaterRecherche(
                                              lot.designationFournisseur
                                            )
                                            .includes(
                                              _vm.formaterRecherche(
                                                _vm.filtreNomProduit
                                              )
                                            ) ||
                                          _vm.rechercheIngredient(
                                            lot,
                                            _vm.formaterRecherche(
                                              _vm.filtreNomProduit
                                            )
                                          )
                                            ? _c(
                                                "tr",
                                                {
                                                  key:
                                                    "zone" +
                                                    iZone +
                                                    "lot" +
                                                    iLot
                                                },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "middle"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            lot.reference
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "aligner-gauche",
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "middle"
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            lot.designationFournisseur
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "middle",
                                                        "max-width": "50px"
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(lot.NumLot)
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "middle",
                                                        "max-width": "50px"
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatHumanDate(
                                                              lot.dlcDluo
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm.inventaireSelectionneNonValide
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "vertical-align":
                                                              "middle",
                                                            "max-width": "50px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.obtenirQteLotEnStock(
                                                                  lot.id
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(lot.uc) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "middle",
                                                        "max-width": "50px"
                                                      }
                                                    },
                                                    [
                                                      _vm.inventaireSelectionneNonValide
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c(
                                                                "InputNumber",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "lotQte" +
                                                                      lot.id,
                                                                    zeroSiVide: true,
                                                                    typeFiltre:
                                                                      "quantite",
                                                                    placeholder:
                                                                      "Quantité"
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.setQuantiteLot(
                                                                        lot,
                                                                        $event
                                                                      )
                                                                    },
                                                                    move: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.moveLot(
                                                                        $event
                                                                      )
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      lot.quantite,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        lot,
                                                                        "quantite",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "lot.quantite"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  lot.quantite
                                                                ) +
                                                                " " +
                                                                _vm._s(lot.uc) +
                                                                " "
                                                            )
                                                          ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "middle"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "afficherPrix"
                                                            )(
                                                              lot.quantite *
                                                                lot.valeurUnitaire
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _vm.inventaireSelectionneNonValide
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "vertical-align":
                                                              "middle"
                                                          }
                                                        },
                                                        [
                                                          _c("ToggleButton", {
                                                            key: _vm.keyToggle,
                                                            staticClass: "mt-1",
                                                            attrs: {
                                                              color: {
                                                                checked:
                                                                  "#16D39A",
                                                                unchecked:
                                                                  "#CCCCCC"
                                                              },
                                                              height: 12,
                                                              width: 20
                                                            },
                                                            model: {
                                                              value:
                                                                lot.quantiteVerifiee,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  lot,
                                                                  "quantiteVerifiee",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "lot.quantiteVerifiee"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ]
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }